import styled from '@emotion/styled';
import { type FC, useState } from 'react';
import { useHighlightedTrackers } from '../../../lib/customHooks';
import { AddOrSelectTagModal } from '../../BasicComponents/CreateTagModal/AddOrSelectTagModal';

export const AddHighlightedTrackersToTagButton: FC = () => {
  const highlightedTrackers = useHighlightedTrackers();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <Container onClick={showModal}>Add or Select Tag</Container>
      <AddOrSelectTagModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        trackers={highlightedTrackers}
      />
    </>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;
